<template>
    <div>
     <!--Header Components-->
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
            <b-row>
                <b-col sm="12">
                    <card>
                        <h3 slot="header" class="mb-0">{{language_terms['APPROVAL_REQUESTS']}}</h3>
                        <b-row>
                            <b-col cols="12" v-if="items.length > 0">
                                <!-- Mail list-->
                                <div class="table-responsive">
                                    <b-table hover striped :fields="fields" :items="items">
                                        <template #head(is_selected)>
                                            <b-form-checkbox id="checkbox-1" name="checkbox-1" value="1" unchecked-value="0" v-model="select_all" @change="clickOnSelectAll">
                                            </b-form-checkbox>
                                        </template>
                                        <template #head(salesperson_contact_name)="data">
                                            <span>{{ language_terms[data.label] }}</span>
                                        </template>
                                        <template #head(contact_name)="data">
                                            <span>{{ language_terms[data.label] }}</span>
                                        </template>
                                        <template #head(code)="data">
                                            <span>{{ language_terms[data.label] }}</span>
                                        </template>
                                        <template #head(time_created)="data">
                                            <span>{{ language_terms[data.label] }}</span>
                                        </template>
                                        <template #cell(is_selected)="data">
                                            <b-form-checkbox  value="1" unchecked-value="0" v-model="data.item.is_selected" >
                                            </b-form-checkbox>
                                        </template>
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>
                                            <template #cell(customer)="data">
                                            <!-- <span class="badge badge-pill text-white font-medium badge-warning mr-2">{{language_terms['PENDING']}}</span> -->
                                            {{ data.item.customer }}
                                        </template>
                                        <template #cell(time_created)="data">
                                            {{ moment(data.item.time_created).format('DD/MM/YYYY, h:mm a') }}
                                        </template>
                                        <template #cell(show_details)="row">
                                    
                                        <base-button @click="row.toggleDetails" size="sm" icon type="success" class="float-right mr-2">
                                            <i :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                                        </base-button>
                                        </template>
                                        <template #row-details="row">
                                                <b-card>
                                                    <div slot="header">
                                                        <b-row>
                                                            <b-col lg="6">
                                                                <h3>{{language_terms['APPROVAL_REQUIRED_FOR']}} </h3>
                                                                    
                                                            </b-col>
                                                            <b-col lg="6">
                                                                <a href="javascript:void(0)" class="float-right" @click="openApprovalRequest(row.item)">
                                                                    <h3 style="color:green">{{row.item.code}}
                                                                        <i class="fa fa-link" ></i>
                                                                    </h3>
                                                                </a>
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                    <b-row>
                                                        <b-col cols="12" v-if="row.item.require_approval_reason">
                                                            <base-input :label="language_terms['REASON']" v-model="row.item.require_approval_reason" disabled></base-input>
                                                        </b-col>
                                                        <b-col cols="12">
                                                            <b-table-simple hover responsive striped>
                                                                <b-thead head-variant="light">
                                                                    <b-th>{{language_terms['PRODUCT']}}</b-th>
                                                                    <b-th>{{language_terms['QTY']}}</b-th>
                                                                    <b-th>{{language_terms['UOM']}}</b-th>
                                                                    <b-th>{{language_terms['LIST_PRICE']}}</b-th>
                                                                    <b-th>{{language_terms['UNIT_PRICE']}}</b-th>
                                                                    <b-th>{{language_terms['AMOUNT']}}</b-th>
                                                                    <b-th>{{language_terms['REASON']}}</b-th>
                                                                </b-thead>
                                                                <b-tbody>
                                                                    <tr v-for="(row, index) in row.item.items" :key="index">
                                                                        <td>{{(row.product_name == null || row.product_name == "") ? row.product_name_master : row.product_name}}</td>
                                                                        <td>{{row.qty}}</td>
                                                                        <td>{{row.uom}}</td>
                                                                        <td>{{row.sale_list_price ? row.sale_list_price : '-'}}</td>
                                                                        <td><span style="color:red">{{row.unit_price}}</span></td>
                                                                        <td>{{row.gross_amount}}</td>
                                                                        <td><span style="color:red">{{row.require_approval_reason}}</span></td>
                                                                    </tr>
                                                                </b-tbody>
                                                            </b-table-simple>
                                                        </b-col>
                                                        <b-col cols="12">
                                                            <base-button icon type="danger" class="float-right mr-1" @click="rejectDocument(row.item)" >
                                                                {{language_terms['REJECT']}}
                                                            </base-button>
                                                            <base-button icon type="success" class="float-right mr-4" @click="approveDocument(row.item)" >
                                                                {{language_terms['APPROVE']}}
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-card>
                                        </template>
                                    </b-table>
                                </div>
                            </b-col>
                            <b-col cols="12"  v-else>
                                {{language_terms['NO_DATA']}}
                            </b-col>
                        </b-row>
                        <b-row v-if="selected_request_count > 0">
                            <b-col cols="6">
                            <div>{{language_terms['SELECTED_REQUESTS']}} : <span style='color:green;font-weight:bold'>{{this.selected_request_count}}</span></div>
                            </b-col>
                            <b-col cols="6">
                                <base-button icon type="danger" class="float-right mr-1" @click="rejectDocuments" >
                                    {{language_terms['REJECT']}} 
                                </base-button>
                                <base-button icon type="success" class="float-right mr-4" @click="approveDocuments" >
                                    {{language_terms['APPROVE']}}
                                </base-button>
                            </b-col>
                        </b-row>
                    </card>
                </b-col>
            </b-row>
   
        </b-container>
    </div>
</template>
<script>
import { mapState } from "vuex";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import moment from 'moment'

import { Select, Option } from "element-ui";

export default {
    data(){
        return{
            select_all:0,
            selected_request_ids:[],
            selected_request_count:0,
            fields:[
                { key: 'is_selected', label:' ', width:'10px'},
                { key: 'index', label:'S/NO', width:'10px'},
                { key: 'salesperson_contact_name', label: 'SENDER' },
                { key: 'contact_name', label: 'CUSTOMER' },
                { key: 'code', label: 'DOCUMENT_NUMBER' },
                { key: 'time_created', label: 'TIME_CREATED' },
                { key: 'show_details', label:' ', width:'10px'},

            ],
            items:[],
            loading:false
        }
    },
    components:{
        Loading,
        [Select.name]: Select,
        [Option.name]: Option
    },
    watch:{
        items: {
          handler(val){
              let count = 0;

              for(let i = 0; i < val.length; i++)
              {
                  if(val[i].is_selected == 1)
                  {
                      count++;
                  }
              }

              if(count == val.length)
              {
                  this.select_all = 1
              }
              else
              {
                  this.select_all = 0
              }

              this.selected_request_count = count
          },
          deep:true
      }
    },
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            approval_requests: state => state.auth.approval_requests,
            is_approved: state => state.sales.is_approved,
            is_rejected: state => state.sales.is_rejected
         })
    },
    async mounted()
    {
        this.loading = true
        await this.retrieveAllRequests()
        this.loading = false
    },
    methods:
    {
        async approveDocuments()
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRM'], {    
                confirmButtonText: this.language_terms['YES'],
                cancelButtonText: this.language_terms['NO'],
                type: 'warning'
            }).catch(() => 
            {
                this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') 
            {
                this.loading = true
                await this.$store.dispatch("sales/approveDocuments", {approval_requests: this.items})
                if(this.is_approved)
                {
                    await this.retrieveAllRequests();
                }
                this.loading = false
            }
        },
        async rejectDocuments()
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRM'], {    
                confirmButtonText: this.language_terms['YES'],
                cancelButtonText: this.language_terms['NO'],
                type: 'warning'
            }).catch(() => 
            {
                this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') 
            {
                this.loading = true
                await this.$store.dispatch("sales/rejectDocuments", {approval_requests: this.items})

                if(this.is_rejected)
                {
                    await this.retrieveAllRequests();
                }
                this.loading = false
            }
        },
        clickOnSelectAll()
        {
            if(this.select_all == 1)
            {
                for(let x= 0; x < this.items.length; x++)
                {
                    this.items[x].is_selected = 1
                }
            }
            else
            {
                for(let x= 0; x < this.items.length; x++)
                {
                    this.items[x].is_selected = 0
                }
            }
        },
        moment: function () {
            return moment();
        },
        async approveDocument(request)
        {
            if(request.id)
            {
                    let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRM'], {    
                        confirmButtonText: this.language_terms['YES'],
                        cancelButtonText: this.language_terms['NO'],
                        type: 'warning'
                    }).catch(() => 
                    {
                        this.$message.info(this.language_terms['ACTION_CANCEL'])
                    })
                    if (response === 'confirm') 
                    {
                        this.loading = true
                        await this.$store.dispatch("sales/approveDocument", {document_id:request.id})

                        if(this.is_approved)
                        {
                            await this.retrieveAllRequests()

                        } 
                        this.loading =false
                    }
            }
        },
        async rejectDocument(request)
        {
            if(request.id)
            {
                    let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRM'], {    
                        confirmButtonText: this.language_terms['YES'],
                        cancelButtonText: this.language_terms['NO'],
                        type: 'warning'
                    }).catch(() => 
                    {
                    this.$message.info(this.language_terms['ACTION_CANCEL'])
                    })
                    if (response === 'confirm') 
                    {
                        this.loading = true
                        await this.$store.dispatch("sales/rejectDocument", {document_id:request.id})

                        if(this.is_rejected)
                        {
                            await this.retrieveAllRequests()
                        } 
                        this.loading =false
                    }
            }
        },
        openApprovalRequest(data)
        {
            //this.$router.push(data.url + "?mode=approval")
            let url = null
            if(data.type == 'SQ')
            {
                url = "/sales/sales-quotation/" + data.code
            }
            else if(data.type == 'SO')
            {
                url = "/sales/sales-order/" + data.code

            }
            else if(data.type == 'SI')
            {
                url = "/sales/sales-invoice/" + data.code

            }
            //console.log(data)

            this.$router.push(url + "?mode=approval")

        },
        async retrieveAllRequests()
        {
            await this.$store.dispatch("auth/fetchApprovalRequests", {})
            this.items = this.approval_requests
        }   
    }
}
</script>
